import { KoDate, KoForm, KoFormBuilder, KoSelect, CURRENCIES, KoLoader, Checkbox, KoTextArea } from 'packages';
import { AssetsAPI } from 'pages/workspace/process/assets/assets.service';
import React, { useCallback, useEffect, useState } from 'react';
import { Country} from 'country-state-city';


const RecurringExpenses = () => {
  const [form] =KoForm.useForm();
  const [countriesList] = useState(Country.getAllCountries());
  const [isLoading, setLoading] = useState(false);
  const [customersList, setDataList] = useState();


  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setLoading(true);
    AssetsAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const RecurrenceValues = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekdays Only (Mon–Fri)', value: 'weekday' },
    { label: 'Weekly (Same Day)', value: 'weekly' },
    { label: 'Weekends Only (Sat–Sun)', value: 'weekends' },
    { label: 'Monthly (Same Date)', value: 'monthly' }
  ];
  
  const Recurrence = ({ value, onChange }) =>
  
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose recurrence'
      options={RecurrenceValues?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };

  const account = [
    { label: 'Account01', value: 'Account01' },
    { label: 'Account02', value: 'Account02' },
    { label: 'Account03', value: 'Account03' },
    { label: 'Account04', value: 'Account04' },
    { label: 'Account05', value: 'Account05' }
  ];
  
  const ExpenseAccount = ({ value, onChange }) =>
    
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose Expense Account'
      options={account?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;


  const Currency = ({ value, onChange }) =>
    <KoSelect value={value}
      showSearch
      onChange={v => onChange(v)}
      placeholder='Select currency'
      options={CURRENCIES?.map((currency) => ({
        label: currency?.code + '-' + currency?.name,
        value: currency?.code
      }))} />;
    
  const Throught = [
    { label: 'Gay Pay', value: 'gaypay' },
    { label: 'Bank Account', value: 'bankaccount' },
    { label: 'Phone Pay', value: 'phonepay' },
    { label: 'Paytm', value: 'paytm' }
  ];

  const PaidThrough = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose Paid Through'
      options={Throught?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const options = [
    { label: 'Goods', value: 'goods' },
    { label: 'Service', value: 'service' }];

  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const CountrySelect = ({ value, onChange }) =>
    <KoSelect showSearch value={value}
      onChange={(v) => onChange(v)}
      placeholder={'Select Country'}
      options={countriesList?.map((country) => ({
        label: country?.name,
        value: country?.isoCode
      }))} />;
  const CheckBox = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`This transaction is applicable for reverse charge`}</Checkbox>;


  const Taxes = [
    { label: 'Non-Texable', value: 'non-texable' },
    { label: 'IGST0 [0%]', value: '0' },
    { label: 'IGST5 [5%]', value: '5' },
    { label: 'IGST10 [10%]', value: '10' }
  ];
  const Tax  = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Select a Tax'
      options={Taxes?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;
  const report1 = [
    { label: 'quaerat', value: 'ad' },
    { label: 'et', value: 'blanditiis' }
  ];
  const report2 = [
    { label: 'soluta', value: 'soluta' },
    { label: 'adipisci', value: 'adipisci' }
  ];

  const ad = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Select a Tax'
      options={report1?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const blanditiis = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Select a Tax'
      options={report2?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'profileame', placeholder: 'Enter Profile Name', label: 'Profile Name' , colSpan: 2, rules: [ {  required: true,  message: `Enter new profile's first name.` } ] },
      { key: 'recurrence', label: 'Recurrence', colSpan: 2, widget: Recurrence },
      { key: 'startDate', label: 'Start Date', colSpan: 2, widget: Date },
      { key: 'endDate', label: 'End Date', colSpan: 2, widget: Date },
      { key: 'expenseaccount', label: 'Expense Account', colSpan: 4, widget: ExpenseAccount },
      { key: 'currency', label: 'Account', colSpan: 2, widget: Currency },
      { key: 'paidthrough', label: 'Paid Through', colSpan: 2, widget: PaidThrough },
      { label:'Expense Type', colSpan: 4, key: 'expensetype', widget: 'radioGroup', direction: 'horizontal',  options },
      { key: 'sac', placeholder: 'Enter SAC', label: 'SAC' , colSpan: 2},
      { key: 'ventors', label: 'Vendor', colSpan: 2, widget: Customers },
      { key: 'primaryDetails.nationality',label: 'Source Of Supply', colSpan: 2, widget: CountrySelect },
      { key: 'primaryDetails.nationality',label: 'Destination Of Supply', colSpan: 2, widget: CountrySelect },
      { key: 'reversecharge', colSpan: 4, label: 'Reverse Charge', widget: CheckBox },
      { key: 'customers', label: 'Customer Name', colSpan: 2, widget: Customers },
      { key: 'tax', label: 'Tax', colSpan: 2, widget: Tax , placeholder: 'Enter a Tax'},
      { key: 'description', widget: KoTextArea, label: 'Notes', colSpan: 6, placeholder: 'Enter a Notes...'},
      {
        key: 'reportingtags',
        colSpan: 4,
        render() {
          return (
            <fieldset>
              <legend>Reporting Tags</legend>
            </fieldset>
          );
        }
      },
      { key: 'ad', label: 'ad', colSpan: 2, widget: ad },
      { key: 'blanditiis', label: 'blanditiis', colSpan: 2, widget: blanditiis }
    ]
  };
  const handleSubmit =useCallback((values)=>{
    console.log(values);
  },[form]);


  return (
    <div>
      {isLoading&& <KoLoader/>}
      <KoForm  form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm></div>
  );
};

export default RecurringExpenses;